import { render, staticRenderFns } from "./LexonCurrencyComponent.vue?vue&type=template&id=762db904&scoped=true&lang=pug"
import script from "./LexonCurrencyComponent.vue?vue&type=script&lang=ts"
export * from "./LexonCurrencyComponent.vue?vue&type=script&lang=ts"
import style0 from "./LexonCurrencyComponent.vue?vue&type=style&index=0&id=762db904&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762db904",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('762db904')) {
      api.createRecord('762db904', component.options)
    } else {
      api.reload('762db904', component.options)
    }
    module.hot.accept("./LexonCurrencyComponent.vue?vue&type=template&id=762db904&scoped=true&lang=pug", function () {
      api.rerender('762db904', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/fields/LexonCurrency/LexonCurrencyComponent.vue"
export default component.exports